import BaseApi from '@/api/controller/base';

const BLACKLIST_API_URL = 'blacklist/';

class BlacklistApi extends BaseApi {
  constructor() {
    super(BLACKLIST_API_URL);
  }

  getAll() {
    return this.api.get('');
  }

  add(ssn) {
    return this.api.post('', { ssn });
  }

  remove(id) {
    return this.api.delete(`${id}`);
  }

  purge() {
    return this.api.delete('');
  }

  import(file, mode) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mode', mode);
    return this.api.post('import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  export() {
    return this.api.get('export', {
      responseType: 'blob',
    });
  }

  exportPriorYear() {
    return this.api.get('export-prior-year', {
      responseType: 'blob',
    });
  }
}

const apiInstance = new BlacklistApi();
export { BlacklistApi, apiInstance };
export default apiInstance;
